import { useEffect } from "react";

interface SeoOptions {
  title: string;
  description: string;
  keywords?: string;
  path?: string;
  jsonLd?: object[];
  noindex?: boolean;
}

const BASE = "https://gjkmv.cn";
const SITE_NAME = "明星黑料档案";

function upsertMeta(attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel: string, href: string) {
  let el = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function setJsonLd(list: object[]) {
  document.querySelectorAll("script[data-seo-jsonld]").forEach((n) => n.remove());
  list.forEach((obj) => {
    const s = document.createElement("script");
    s.type = "application/ld+json";
    s.setAttribute("data-seo-jsonld", "1");
    s.textContent = JSON.stringify(obj);
    document.head.appendChild(s);
  });
}

export default function useSeo({
  title,
  description,
  keywords,
  path = "/",
  jsonLd = [],
  noindex = false,
}: SeoOptions) {
  useEffect(() => {
    const url = `${BASE}${path === "/" ? "/" : path}`;
    document.title = title;
    upsertMeta("name", "description", description);
    if (keywords) upsertMeta("name", "keywords", keywords);
    upsertMeta("name", "robots", noindex ? "noindex, follow" : "index, follow");
    upsertLink("canonical", url);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", url);
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    setJsonLd(jsonLd);
    return () => {
      /* keep canonical in SPA document */
    };
  }, [title, description, keywords, path, noindex, jsonLd]);
}

export { BASE, SITE_NAME };